import { ScanFace } from "lucide-react";
import { Button, Icon, Spinner, Wordmark } from "@cntrl/ui";
import styles from "./LockScreen.module.scss";

export interface LockScreenProps {
  /** A biometric prompt is in flight (disable the button, show a spinner). */
  prompting: boolean;
  /** Retry the biometric unlock (re-invokes the OS prompt). */
  onUnlock: () => void;
}

/**
 * The native Face-ID lock surface. Shown by {@link BiometricGate} when a held session is
 * locked and the OS prompt was cancelled/failed — the same brand posture as the boot splash so a locked cold
 * launch never flashes authed content. Web never renders this (the gate no-ops off native).
 */
export function LockScreen({ prompting, onUnlock }: LockScreenProps) {
  return (
    <div className={styles.lock} role="status" aria-live="polite">
      <div className={styles.brand}>
        <Wordmark size={32} />
      </div>
      <div className={styles.badge} aria-hidden="true">
        <Icon icon={ScanFace} size={22} />
      </div>
      <h1 className={styles.title}>CNTRL is locked</h1>
      <p className={styles.subtitle}>Unlock with Face ID to continue.</p>
      {prompting ? (
        <Spinner size={20} label="Waiting for Face ID" />
      ) : (
        <Button onClick={onUnlock} type="button">
          Unlock
        </Button>
      )}
    </div>
  );
}
